import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RelatedItem } from '../../models/related-items-result';
import { ItemDetailsComponent } from '../item-details/item-details.component';
import { isEmptyMessage } from 'core/utils/empty-message';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FeatureToggleService } from 'app/services/feature-toggle.service';

@Component({
  selector: 'app-location-table',
  templateUrl: './location-table.component.html',
  styleUrls: ['./location-table.component.scss'],
})
export class LocationTableComponent implements OnInit {
  @Input() public itemTitle: string;
  @Input() public tableItems: RelatedItem[];
  public showSpecialColumn = false;
  public isEmptyMsg = isEmptyMessage;
  public readonly infoCircle = faInfoCircle
  public featureNewEditionsUXDesign: boolean;
  constructor(
    private readonly dialog: NgbModal,
    private readonly featureToggleService: FeatureToggleService,
  ) {
  }

  ngOnInit(): void {
    this.featureNewEditionsUXDesign = this.featureToggleService.getToggles()['VDIS-33338_2025-12-31_new_editions_UX_design'];
    this.showSpecialColumn = this.tableItems.some((item) => item.rareContentLink);
  }

  showDetails(item: RelatedItem) {
    const modalRef = this.dialog.open(ItemDetailsComponent, { windowClass: undefined });
    modalRef.componentInstance.itemTitle = this.itemTitle;
    modalRef.componentInstance.item = item;
  }
}
